import { CATEGORIES_SUBTITLES } from './categories-subtitles';

export const TOP_STYLE_CATEGORIES = [
  CATEGORIES_SUBTITLES.specificEducationalApproach,
  CATEGORIES_SUBTITLES.coreKnowledge,
  CATEGORIES_SUBTITLES.highSchoolPrograms,
  CATEGORIES_SUBTITLES.schoolCurriculum,
];
